var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 79,
    viewBox: "0 0 67 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6946 64.9581C55.6767 61.3261 66 48.6186 66 33.5C66 15.5507 51.4493 1 33.5 1C15.5507 1 1 15.5507 1 33.5C1 48.1716 10.7218 60.5725 24.0749 64.6123L33 78L41.6946 64.9581Z",
    fill: "#00C781"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6946 64.9581L41.5689 64.4742L41.3843 64.5221L41.2786 64.6808L41.6946 64.9581ZM24.0749 64.6123L24.4909 64.3349L24.3914 64.1857L24.2197 64.1337L24.0749 64.6123ZM33 78L32.584 78.2774L33 78.9014L33.416 78.2774L33 78ZM65.5 33.5C65.5 48.3853 55.336 60.898 41.5689 64.4742L41.8203 65.4421C56.0174 61.7542 66.5 48.8519 66.5 33.5H65.5ZM33.5 1.5C51.1731 1.5 65.5 15.8269 65.5 33.5H66.5C66.5 15.2746 51.7254 0.5 33.5 0.5V1.5ZM1.5 33.5C1.5 15.8269 15.8269 1.5 33.5 1.5V0.5C15.2746 0.5 0.5 15.2746 0.5 33.5H1.5ZM24.2197 64.1337C11.0716 60.156 1.5 47.9451 1.5 33.5H0.5C0.5 48.398 10.372 60.9891 23.9301 65.0909L24.2197 64.1337ZM33.416 77.7226L24.4909 64.3349L23.6588 64.8896L32.584 78.2774L33.416 77.7226ZM41.2786 64.6808L32.584 77.7226L33.416 78.2774L42.1106 65.2355L41.2786 64.6808Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9507 32.0421C46.2275 32.0421 48.8839 29.3857 48.8839 26.1089C48.8839 22.8321 46.2275 20.1758 42.9507 20.1758C39.6739 20.1758 37.0176 22.8321 37.0176 26.1089C37.0176 29.3857 39.6739 32.0421 42.9507 32.0421Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0622 45.3642C54.0622 45.8582 54.0387 46.3287 54.0152 46.811H31.8894C31.8541 46.3287 31.8306 45.8582 31.8306 45.3642C31.8118 42.7416 32.3323 40.1431 33.3597 37.7301C33.5319 37.7458 33.7051 37.7458 33.8773 37.7301C36.1636 37.6716 38.3521 36.7904 40.041 35.2481C40.1233 35.2834 40.2174 35.3069 40.3115 35.3422C41.1689 35.5842 42.0555 35.707 42.9464 35.7069C45.371 35.7102 47.7057 34.7889 49.4748 33.1309C52.544 36.4523 54.1908 40.8435 54.0622 45.3642Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2847 32.0421C27.5615 32.0421 30.2179 29.3857 30.2179 26.1089C30.2179 22.8321 27.5615 20.1758 24.2847 20.1758C21.0079 20.1758 18.3516 22.8321 18.3516 26.1089C18.3516 29.3857 21.0079 32.0421 24.2847 32.0421Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3954 45.3642C35.3954 45.8582 35.3837 46.3287 35.3484 46.811H13.2226C13.1873 46.3287 13.1755 45.8582 13.1755 45.3642C13.0416 40.8426 14.689 36.4494 17.763 33.1309C19.5274 34.7889 21.8585 35.7104 24.2796 35.7069C25.1743 35.707 26.0649 35.5842 26.9262 35.3422C27.0203 35.3069 27.1027 35.2834 27.1968 35.2481C28.8844 36.7923 31.0737 37.6738 33.3605 37.7301C33.5327 37.7458 33.7059 37.7458 33.8781 37.7301C34.896 40.1456 35.4123 42.7429 35.3954 45.3642Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6167 34.0753C36.8935 34.0753 39.5499 31.4189 39.5499 28.1421C39.5499 24.8653 36.8935 22.209 33.6167 22.209C30.34 22.209 27.6836 24.8653 27.6836 28.1421C27.6836 31.4189 30.34 34.0753 33.6167 34.0753Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7356 47.3993C44.7356 47.8816 44.7121 48.3639 44.6768 48.8461H22.551C22.5274 48.3639 22.5039 47.8816 22.5039 47.3993C22.5039 47.1993 22.5039 47.0111 22.5157 46.8112C22.5262 42.576 24.0966 38.4932 26.9267 35.3425C26.9784 35.2807 27.0334 35.2219 27.0914 35.166C27.1237 35.1971 27.1592 35.2247 27.1973 35.2484C28.8849 36.7925 31.0742 37.674 33.361 37.7303C33.5331 37.746 33.7064 37.746 33.8785 37.7303C36.1649 37.6718 38.3534 36.7906 40.0422 35.2484C40.0803 35.2247 40.1157 35.1971 40.1481 35.166C40.2061 35.2219 40.2611 35.2807 40.3128 35.3425C43.1429 38.4932 44.7132 42.576 44.7238 46.8112C44.7356 47.0111 44.7356 47.1993 44.7356 47.3993Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 1.6,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManPower);
export default __webpack_public_path__ + "static/media/manPower.8c5ce2f96a9777bdab1e476e606dddf7.svg";
export { ForwardRef as ReactComponent };